// extracted by mini-css-extract-plugin
module.exports = {"note":"XU3iwu","shine-lines":"jGNgzP"};